

import { FormGroup } from '@angular/forms';

import { retry, catchError } from 'rxjs/operators';
import { GlobalService } from 'src/app/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { debug } from 'util';
import { Observable } from 'rxjs';



@Injectable({ providedIn: "root" })
export class LoginService {


  constructor(private http: HttpClient, private global: GlobalService) {

  }
  public getPaymentOfMode(P_MODE_PAY){
    return this.http.get(this.global.BaseMedicalurl+this.global.getModeOfPayments,P_MODE_PAY);
  }
  public login(obj) {
    
    // alert("services"+this.global.Baseurl+this.global.loginRouting);
    // var logintesturl="http://localhost:8086/NICPORTALB2B/api/";
    return this.http.post(this.global.Baseurl + this.global.loginRouting, obj);
  }

  public usercreation(usercreateform, productlist) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.userrouting + "/" + productlist, usercreateform, { headers: headers });

  }

  public usercreationSMS(username) {
    
    return this.http.get(this.global.Baseurl + this.global.usercreationsms + "/" + username)
  }

  public getagentListing() {
    return this.http.get(this.global.Baseurl + this.global.agentListingWS);
  }

  public changepassword(passwordform) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.changeRouting, passwordform, { headers: headers });
  }

  public useridValidation(username) {
    
    console.log(this.global.Baseurl + this.global.useridValidationrouting);
    return this.http.get(this.global.Baseurl + this.global.useridValidationrouting + "/" + username);
  }
  public emailidValidation(emailid): Observable<any> {
    
    console.log(this.global.Baseurl + this.global.emailidValidation);
    return this.http.get(this.global.Baseurl + this.global.emailidValidation + "/" + emailid);
  }

  public forgetForm(username, type) {
    console.log(this.global.Baseurl + this.global.forgotpasswordrouting);
    return this.http.get(this.global.Baseurl + this.global.forgotpasswordrouting + "/" + username + "/" + type);
  }

  public getuserListing(agentId) {
    console.log(this.global.Baseurl + this.global.userListingWS);
    return this.http.get(this.global.Baseurl + this.global.userListingWS + "/" + agentId);

  }
  public getPageLOVs(value: string) {
    console.log("Full URL: ", this.global.Baseurl + this.global.getPageLOVs + value)
    return this.http.get(this.global.Baseurl + this.global.getPageLOVs + value);
  }

  public getuploadListing() {
    return this.http.get(this.global.Baseurl + this.global.uploadListingWS);
  }

  public contact(contactform) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.contactWS, contactform, { headers: headers });
  }
  public getpromotionListing() {
    
    return this.http.get(this.global.Baseurl + this.global.promotionListingWS);
  }

  public editUserDetails(username) {
    
    console.log("Full URL: ", this.global.Baseurl + this.global.editUserDetailsRouting + "/" + username)
    return this.http.get(this.global.Baseurl + this.global.editUserDetailsRouting + "/" + username);
  }

  public notification(pushNotification) {
    
    console.log("Full URL: ", this.global.Baseurl + this.global.notificationRouting);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.notificationRouting, pushNotification, { headers: headers });
  }

  public getnotificationListing(agentId) {
    
    return this.http.get(this.global.Baseurl + this.global.notificationListingWS + "/" + agentId);
  }

  public submitRemarksRequest(data: any) {
    
    return this.http.post(this.global.Baseurl + this.global.remarksviewedRouting, data);
  }

  public getViewednotificationListing(agentId) {
    
    return this.http.get(this.global.Baseurl + this.global.ViewednotificationListingWS + "/" + agentId);
  }
  public usercreationedit(usercreateform, productlist) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post(this.global.Baseurl + this.global.useredit + "/" + productlist, usercreateform);
  }
  public getproductlist(userName) {
    
    return this.http.get(this.global.Baseurl + this.global.productListingWS + "/" + userName);
  }

  public getfileType() {
    
    return this.http.get(this.global.Baseurl + this.global.fileListingWS);
  }
  //for travel check list 
  public getfileTypetravel(prodcode) {
    
    return this.http.get(this.global.Baseurl + this.global.fileListingtravel + "/" + prodcode);
  }
  public updateprofile(Form) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.updateProfile, Form, { headers: headers });
  }

  public viewprofile(userName) {
    return this.http.get(this.global.Baseurl + this.global.viewprofile + "/" + userName);
  }

  public getloginuser(val) {
    
    return this.http.get(this.global.Baseurl + this.global.getloginusers + "/" + val);

  }

  public savepingeneration(Form) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.generatepin, Form, { headers: headers });
  }

  public getpinGenerationList() {
    
    return this.http.get(this.global.Baseurl + this.global.pinListingWS);
  }

  public getuserType(val) {
    
    return this.http.get(this.global.Baseurl + this.global.getuserType + "/" + val);
  }

  public languageSetup(langlist, value) {
    
    var name;
    for (let i = 0; i < langlist.length; i++) {
      if (i == 0) {
        name = langlist[i];
      }
      else {
        name = name + "," + langlist[i];
      }
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.getLangSetup + "?langlist=" + name + "&&value=" + value, { headers: headers });
  }

  public langauagechange(unselectllist, value1) {
    
    var name1;
    for (let i = 0; i < unselectllist.length; i++) {
      if (i == 0) {
        name1 = unselectllist[i];
      }
      else {
        name1 = name1 + "," + unselectllist[i];
      }
    }
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.getvaluechange + "?unselectllist=" + name1 + "&&value1=" + value1, { headers: headers });
  }

  public checkedvalues(value) {
    
    return this.http.get(this.global.Baseurl + this.global.checkedDetails + "/" + value);
  }
  public sessiontiming(timing, code) {
    console.log("Full URL: ", this.global.Baseurl + this.global.sessionRouting);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.sessionRouting + "?timing=" + timing + "&&code=" + code, { headers: headers });
  }

  public settime(code) {
    
    return this.http.get(this.global.Baseurl + this.global.sessiontime + "/" + code);
  }

  public sessiondetail(code) {
    return this.http.get(this.global.Baseurl + this.global.sessiondetail + "/" + code);
  }


  public getChartListing() {
    return this.http.get(this.global.Baseurl + this.global.chartlistingrouting);
  }

  public getnotificationList(loginuser) {
    return this.http.get(this.global.Baseurl + this.global.notificationlistingrouting + "/" + loginuser);
  }

  public chartsave(DashboardRequest) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.getdashboardChart, DashboardRequest, { headers: headers });
  }

  public chartEdit(obj) {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.getchartEdit, obj, { headers: headers });
  }

  public getProductdescription() {
    
    return this.http.get(this.global.Baseurl + this.global.productDescritionrouting);
  }

  public getfaqlist(product) {
    
    return this.http.get(this.global.Baseurl + this.global.faqdescrouting + "/" + product);
  }

  getreceiptPolicyDetails(polNo): Observable<any> {
    let obj = {
      "polNo": polNo
    }
    return this.http.post(this.global.Baseurl + this.global.getreceiptPolicyDetails, obj)

  }
  getreceiptMedPolicyDetails(polNo): Observable<any> {
    let obj = {
      "polNo": polNo
    }
    return this.http.post(this.global.BaseMedicalurl + this.global.getreceiptMedPolicyDetails, obj)

  }
  getreceiptCustomerDetails(custcode): Observable<any> {
    let obj = {
      "custcode": custcode
    }
    return this.http.post(this.global.Baseurl + this.global.getreceiptCustomerDetails, obj)

  }
  getaccountdetails(bankCode): Observable<any> {
    let obj = {
      "bankCode": bankCode
    }
    return this.http.post(this.global.Baseurl + this.global.getaccountdetails, obj)

  }

  public saveReceiptDetails(obji) {
    return this.http.post(this.global.Baseurl + this.global.saveReceiptDetails, obji)

  }

  public receiptscreenDetail(RHsysid) {
    return this.http.get(this.global.Baseurl + this.global.receiptscreenDetail + "?RHsysid=" + RHsysid)

  }

  public submitrespond(obj) {
    return this.http.post(this.global.Baseurl + this.global.submitresponse, obj)
  }

  public getprodlist(val) {
    
    return this.http.get(this.global.Baseurl + this.global.getprodlist + "/" + val)

  }

  public getimageuploadlist() {
    
    return this.http.get(this.global.Baseurl + this.global.getimageuploadlist);

  }

  public viewImg(id) {
    
    return this.http.get(this.global.Baseurl + this.global.viewImg + "/" + id)

  }


  public getuploadList(quoteNo) {
    
    return this.http.get(this.global.Baseurl + this.global.getuploadList + "?quoteNo=" + quoteNo)

  }

  public verifyUploadDocument(quoteNo) {
    
    return this.http.get(this.global.Baseurl + this.global.verifyUploadDocument + "?quoteNo=" + quoteNo);

  }

  public validateUsername(userName) {
    
    return this.http.get(this.global.Baseurl + this.global.validateUsername + "/" + userName);

  }
  public submitNotes(obj) {
    
    return this.http.post(this.global.Baseurl + this.global.submitNotes, obj);
  }

  public verifyProposalQuestDtls(quoteNo) {
    
    return this.http.get(this.global.Baseurl + this.global.verifyProposalQuestDtls + "?quoteNo=" + quoteNo);
  }
  ///////////////////////// Medical /////////////////
  public receiptMedscreenDetail(obj) {
    return this.http.get(this.global.BaseMedicalurl + this.global.receiptMedscreenDetail + "?polNo=" + obj.polNo)

  }
  public customerData(obj) {
    return this.http.get(this.global.BaseMedicalurl + this.global.getMedCustomerData + "?custCode=" + obj.custCode)

  }
  public receiptDeposit(obj) {
    return this.http.post(this.global.BaseMedicalurl + this.global.getReceiptDeposit, obj)

  }
  public receiptApprove(obj) {
    return this.http.post(this.global.BaseMedicalurl + this.global.getReceiptApprove, obj)

  }
  public leadCreation(quoteDetails) {
    
    return this.http.post(this.global.Baseurl + this.global.leadCreation, quoteDetails);
  }


  public getbranchdetails(bankcode, branchCode): Observable<any> {
    
    return this.http.get(this.global.Baseurl + this.global.getbranchdetails + "/" + bankcode + "/" + branchCode);
  }

  public getBranchLovService(data: any) {
    return this.http.get(this.global.Baseurl + this.global.getbranchlovrouting + "" + data);
  }

  public getCollectionDetails(quoteNo, bankCode): Observable<any> {
    
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.global.Baseurl + this.global.getCollectionDetails + "?quoteNo=" + quoteNo + "&&bankCode=" + bankCode, { headers: headers });
  }

  public saveBankdetails(obj) {
    
    return this.http.post(this.global.Baseurl + this.global.saveBankdetails, obj)

  }
  public getBankdtls (quoteNo){
  
  return this.http.get(this.global.Baseurl + this.global.getBankdtls + "?quoteNo=" + quoteNo)
 }

 public verifyBankDetails(quoteNo) {
  
  return this.http.get(this.global.Baseurl + this.global.verifyBankDetails + "?quoteNo=" + quoteNo);

}

public serviceRequest(obj){
  
  return this.http.post(this.global.Baseurl + this.global.serviceRequest, obj)
}

public serviceReqListing(loginUser){

return this.http.get(this.global.Baseurl + this.global.serviceReqListing + "?loginUser=" + loginUser);
  
}
public userNamechange(userName){
  
return this.http.get(this.global.Baseurl + this.global.userNamechange + "/" + userName);

}

public getPayType(quoteNo){

return this.http.get(this.global.Baseurl+this.global.getPayType+"?quoteNo="+quoteNo);

}

}